import { useFoundation } from '@picsart/design-system/hooks/initFoundation';

const useThemeChange = ({ disableFavicons }: { disableFavicons: boolean }) => {
  useFoundation({ writingMode: 'ltr', disableFavicons });
};

export default useThemeChange;
